import { Component } from '@angular/core';
import { AppData } from '../../../app-data';
import { Pocket } from '../../../model/api/common/device';
import { Param } from '../../../model/common/param';
import { GenericTableList } from '../../generic/generic.table.list';
@Component({
    selector: 'device-list',
    templateUrl: '../../generic/generic.table.list.html'
})
export class DeviceList extends GenericTableList<Pocket, number> {
    private listName: string = 'DEVICES';

    constructor() {
        super('code', 'asc', '');
        this.columns = AppData.ColumnDefinitions[this.listName];
    }

    public refresh(filters: Array<Param>) {
        this.columns = AppData.ColumnDefinitions[this.listName];
        super.refresh(filters);
    }
}